import React from 'react'
import { Typography, withStyles } from '@material-ui/core'
import { CoreToggleButtonGroup, CoreToggleButton } from 'src/components/core'
import { Icon } from '@iconify/react'
import styles from './styles'
import { useSelector } from 'react-redux'
import Badge from './badge'
const ResourceTypeSelector = ({
  classes,
  resourceType,
  onResourceTypeChange,
  mode,
  disableCourse,
}) => {
  const handleResourceType = (event, newResourceType) => {
    if (newResourceType !== null) {
      onResourceTypeChange(newResourceType)
    }
  }

  return (
    <CoreToggleButtonGroup
      value={resourceType}
      onChange={handleResourceType}
      exclusive
      fullWidth
      label="SELECT SOURCE"
    >
      <CoreToggleButton value="course" disabled={disableCourse}>
        <Icon icon="mynaui:book-open" />
        <Typography className={classes.header}>
          {mode === 'page' ? 'Course source' : 'Use existing content'}
        </Typography>
      </CoreToggleButton>

      <CoreToggleButton value="ai">
        <Icon icon="hugeicons:ai-book" />
        <Typography className={classes.header}>AI knowledge base</Typography>
      </CoreToggleButton>
      <CoreToggleButton value="pdf">
        <Icon icon="proicons:file" />

        <Typography className={classes.header}>My resources</Typography>
        <Badge />
      </CoreToggleButton>
    </CoreToggleButtonGroup>
  )
}

export default withStyles(styles)(ResourceTypeSelector)
